exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FiscalSalesAnalyser{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/fiscal-sales-analyser/fiscal-sales-analyser.scss
// module id = 1344
// module chunks = 0